import Panel from 'bitmovin-web-ui/src/components/generic/panel/index';
import baseVariables from 'bitmovin-web-ui/src/styles/baseVariables/index';
import React from 'react';
import styled from 'styled-components';

import {Product, ProductToAppRoutePath, ProductToHexagonIconSrc, ProductToText} from '../../../data/product';
import OrganizationSvg from '../../../media/quickSwitch/organization.svg';
import {Link, pxToEm} from '../../globalStyles';
import HexagonIconImage, {HexagonSize} from '../../hexagonIconImage';

//#region Styled Components

const StyledProductPanel = styled(Panel)`
  height: 100%;
  width: 100%;
  background-color: ${baseVariables.colors.white};
  padding: ${pxToEm(14)}em;
  border-radius: ${baseVariables.sizes.borderRadius};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;

const StyledIconContainer = styled.div`
  position: relative;
  margin-bottom: ${pxToEm(10)}em;
`;

const StyledOrganizationImg = styled.img`
  position: absolute;
  right: -10%;
  bottom: -5%;
  height: ${pxToEm(30)}em;
  width: ${pxToEm(30)}em;
`;

const StyledTitleDiv = styled.div`
  font-size: ${pxToEm(16)}em;
  font-weight: bold;
  text-align: center;
`;

//#endregion

interface Props {
  product: Product;
}

const ProductTileLink: React.FunctionComponent<Props> = props => {
  const isOnPremisse = props.product === Product.OnPremiseAnalytics || props.product === Product.OnPremiseEncoding;

  return (
    <Link to={ProductToAppRoutePath[props.product]}>
      <StyledProductPanel>
        <StyledIconContainer>
          <HexagonIconImage iconSrc={ProductToHexagonIconSrc[props.product]} size={HexagonSize.Small} />
          {isOnPremisse && <StyledOrganizationImg src={OrganizationSvg} alt="organization" />}
        </StyledIconContainer>

        <StyledTitleDiv>{ProductToText[props.product]}</StyledTitleDiv>
      </StyledProductPanel>
    </Link>
  );
};

export default ProductTileLink;
